import React, { Component, Fragment } from 'react'
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { css, StyleSheet } from 'aphrodite';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { Grid, Card, CardContent, CardActionArea, Tooltip, Paper, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Helper } from '../../../common/helpers/Helper';
import { AppHelper } from '../../../helpers/AppHelper';
import { SubEntityCard } from '../../../common/components/SubEntity/SubEntityCard';
import { SubEntityList } from '../../../common/components/SubEntity/SubEntityList';
import { timesSeries } from 'async';

export class Product extends BaseEntityPage {
  constructor(props) {
    super(props)
    this.pageTitle = 'Product'
    this.noAdd = true
    this.prodId = this.props.match.params.id;
    this.emptyText = ' ' // space
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: 'Products', to: '/admin/products' },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['products', this.prodId],
        { pb: 'fieldDef,fieldDefSEO,fieldDefImages,fieldDefDocs,fieldDefDescr' }) },
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['brands']) },
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['miscs', 'cats']) },
    ]
    this.apiData = {}
  }

  onFetchSuccess(results) {
    console.log('onFetchSuccess:', results)
    this.pageTitle = results[0].title

    this.fieldDef = results[0].fieldDef
    this.fieldDefSEO = results[0].fieldDefSEO
    this.fieldDefDescr = results[0].fieldDefDescr

    this.formDefinition = this.fieldDef
    AppHelper.populateOptions(this.fieldDef, results[1], 'brandId')

    this.cats = results[2].items
    this.catsById = Helper.itemsToMap(this.cats, 'id')
    const leafCats = []
    this.cats.forEach(i => {
      i.parents = []
      if (i.parentId) {
        const parentL2 = this.catsById[i.parentId]
        if (parentL2 && parentL2.parentId) {
          const parentL1 = this.catsById[parentL2.parentId]
          if (parentL1) {
            leafCats.push({
              parents: [parentL1, parentL2],
              id: i.id,
              title: parentL1.title + '/' + parentL2.title + '/' + i.title
            })
          }
        }
      }
    })
    AppHelper.populateOptions(this.fieldDef, { items: leafCats}, 'catIds')

    this.setState({
      item: results[0],
      docs: Helper.dictToArray(results[0].docs),
      images: Helper.dictToArray(results[0].images)
    })

    this.fieldDefImages = results[0].fieldDefImages
    this.imagesTableHeadersMap = {
      title: (current) => current.title,
      order: (current) => current.order,
    }

    this.fieldDefDocs = results[0].fieldDefDocs
    this.docsTableHeadersMap = {
      title: (current) => current.title,
      order: (current) => current.order,
    }

    this.fieldDefParams = this.makeParamsFormDef(results[0])
  }

  renderAboveTable() {
    const { item, docs, images } = this.state
    return (
      <div className={css(Styles.containerNarrow)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <SubEntityCard
              title={'Main'} formDefinition={this.formDefinition}
              item={this.state.item}
              openModalForEdit={this.openModalForEdit.bind(this)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SubEntityCard
              title={'Decriptions'} formDefinition={this.fieldDefDescr}
              item={this.state.item}
              openModalForEdit={(current) => this.openModalForEdit(current, this.fieldDefDescr)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SubEntityCard
              title={'Specifications'} formDefinition={this.fieldDefParams}
              item={this.state.item.params || {}}
              openModalForEdit={(current) => this.openModalForParamsEdit(current, this.fieldDefParams)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SubEntityCard
              title={'SEO'} formDefinition={this.fieldDefSEO}
              item={this.state.item}
              openModalForEdit={(current) => this.openModalForEdit(current, this.fieldDefSEO)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SubEntityList
              title={'Images'}
              tableHeadersMap={this.imagesTableHeadersMap}
              items={images}
              openModalForEdit={(current) => this.openModalForSE({ current, entityAttrName: 'images', entityAction: 'edit'})}
              openModalForDelete={(current) => this.openModalForSE({ current, entityAttrName: 'images', entityAction: 'del'})}
              openModalForAdd={(current) => this.openModalForSE({ current, entityAttrName: 'images', entityAction: 'add'})}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SubEntityList
              title={'Docs'}
              tableHeadersMap={this.docsTableHeadersMap}
              items={docs}
              openModalForEdit={(current) => this.openModalForSE({ current, entityAttrName: 'docs', entityAction: 'edit'})}
              openModalForDelete={(current) => this.openModalForSE({ current, entityAttrName: 'docs', entityAction: 'del'})}
              openModalForAdd={(current) => this.openModalForSE({ current, entityAttrName: 'docs', entityAction: 'add'})}
            />
          </Grid>
        </Grid>
      </div>
    );
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: {},
      apiEndPoint: ApiHelper.makeUrlPath(['products', current.id]),
    });
  }

  openModalForSE(options) {
    const { current, entityAttrName, entityAction } = options
    if (entityAttrName === 'images') {
      this.formDefinition = this.fieldDefImages
    } else if (entityAttrName === 'docs') {
      this.formDefinition = this.fieldDefDocs
    }
    this.formDefinition.formType = entityAction
    if (current) {
      Helper.populateFormDefinitionValues(this.formDefinition, current)
    }
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction, entityAttrName, id: current ? current.id : undefined },
      apiEndPoint: ApiHelper.makeUrlPath(['products', this.prodId]),
      modalOpen: true
    })
  }

  openModalForParamsEdit(current, fieldDef) {
    this.formDefinition = fieldDef
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current || {})
    this.setState({
      apiMethod: 'PUT',
      apiData: { updateAction: 'setParams' },
      apiEndPoint: ApiHelper.makeUrlPath(['products', this.prodId], {}),
      modalOpen: true
    })
  }

  makeParamsFormDef(item) {
    const params = []
    if (!item.catIds) {
      item.catIds = []
    }
    const paramTitles = {}
    item.catIds.forEach(i => {
      const cat = this.catsById[i]
      for (const pId in cat.params) {
        const param = cat.params[pId]

        if (!param.title) continue
        const title = param.title.toLowerCase()
        if (title in paramTitles) continue // Allow only one name

        paramTitles[title] = param
        params.push(param)
      }
    })

    const fields = []
    let index = 0
    params.forEach(i => {
      const field = {
        key: 'key_' + i.id,
        type: 'edit_text',
        label: i.title,
        hint: 'Provide ' + i.title,
        v_required: { value: false, err: 'Provide ' + i.title }, // eslint-disable-line camelcase
        placement: index % 2 === 0 ? 'left' : 'right'
      }
      if (i.paramType === 'TEXT-SHORT') {
        //
      } else if(i.paramType === 'TEXT-PARAGRAPH') {
        field.multiline = true
      }
      index += 1
      fields.push(field)
    })
    return { steps: [ { fields: fields } ]}
  }
}

const Styles = StyleSheet.create({
  containerNarrow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: AppTheme.viewPort,
    paddingBottom: 50,
    width: '100%',
  },
  container: {
    textAlign: 'center',
    maxWidth: AppTheme.viewPort,
    marginBottom: 20,
    width: '100%',
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/product/Product.js